import Forms from '../Forms';
import jQuery from 'jquery';
export default class Contact {
    constructor() {
        this.$contactContents = jQuery('[data-template-contact]');
        if (this.$contactContents.length) {
            new Forms(this.$contactContents);
        }
    }
}
